import * as tslib_1 from "tslib";
import { LineElements, DefaultMaterialManager } from "@awayjs/graphics";
import { GL_RenderableBase } from "@awayjs/stage";
/**
 * @class away.pool.GL_LineSegmentRenderable
 */
var GL_LineSegmentRenderable = (function (_super) {
    tslib_1.__extends(GL_LineSegmentRenderable, _super);
    /**
     * //TODO
     *
     * @param pool
     * @param graphic
     * @param level
     * @param dataOffset
     */
    function GL_LineSegmentRenderable(lineSegment, renderablePool) {
        var _this = _super.call(this, lineSegment, renderablePool) || this;
        _this._lineSegment = lineSegment;
        return _this;
    }
    GL_LineSegmentRenderable.prototype.onClear = function (event) {
        _super.prototype.onClear.call(this, event);
        this._lineSegment = null;
    };
    /**
     * //TODO
     *
     * @returns {base.LineElements}
     * @protected
     */
    GL_LineSegmentRenderable.prototype._getElements = function () {
        var elements = GL_LineSegmentRenderable._lineGraphics[this._lineSegment.id] || (GL_LineSegmentRenderable._lineGraphics[this._lineSegment.id] = new LineElements());
        var start = this._lineSegment.startPostion;
        var end = this._lineSegment.endPosition;
        var positions = new Float32Array(6);
        var thickness = new Float32Array(1);
        positions[0] = start.x;
        positions[1] = start.y;
        positions[2] = start.z;
        positions[3] = end.x;
        positions[4] = end.y;
        positions[5] = end.z;
        thickness[0] = this._lineSegment.thickness;
        elements.setPositions(positions);
        elements.setThickness(thickness);
        return this._stage.getAbstraction(elements);
    };
    GL_LineSegmentRenderable.prototype._getMaterial = function () {
        return this._materialGroup.getMaterialPool(this.elementsGL).getAbstraction(this._lineSegment.material || DefaultMaterialManager.getDefaultMaterial(this.renderable));
    };
    return GL_LineSegmentRenderable;
}(GL_RenderableBase));
export { GL_LineSegmentRenderable };
GL_LineSegmentRenderable._lineGraphics = new Object();



// WEBPACK FOOTER //
// ../dist/lib/renderables/GL_LineSegmentRenderable.js